export const Moneda = (e, inputValue) => {
    if (e && e.value !== inputValue) {
      // Elimina cualquier carácter que no sea un número o un punto
      let cleanedValue = e.value.replace(/[^0-9.]/g, "");
  
      // Si hay más de un punto, elimina los extras
      const dotCount = cleanedValue.split(".").length - 1;
      if (dotCount > 1) {
        cleanedValue = cleanedValue.replace(/\.+$/, "");
      }
  
      // Formatea el número con comas y permite solo dos dígitos después del punto
      cleanedValue = cleanedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      cleanedValue = cleanedValue.replace(/(\.\d{2})\d+$/, '$1');
  
      e.value = cleanedValue;
    }
  };
  